module.exports = __webpack_public_path__ + "static/media/justA.d51483cc.svg";